import apiClient from './client';

export interface SmtpConfig {
  id: string;
  host: string;
  port: number;
  secure: boolean;
  user: string;
  fromName: string;
  fromEmail: string;
  updatedAt: string;
}

export interface SmtpConfigDto {
  host: string;
  port: number;
  secure: boolean;
  user: string;
  password?: string;
  fromName: string;
  fromEmail: string;
}

export async function getSmtpConfig(): Promise<SmtpConfig | null> {
  const { data } = await apiClient.get<SmtpConfig | null>('/smtp');
  return data;
}

export async function saveSmtpConfig(dto: SmtpConfigDto): Promise<SmtpConfig> {
  const { data } = await apiClient.put<SmtpConfig>('/smtp', dto);
  return data;
}

export async function testSmtpConfig(to?: string): Promise<{ message: string }> {
  const { data } = await apiClient.post<{ message: string }>('/smtp/test', { to });
  return data;
}

export async function deleteSmtpConfig(): Promise<void> {
  await apiClient.delete('/smtp');
}
